<i18n>
{
  "fr": {
      "title": "Création du formulaire VPT",
      "titleForm": "Visite Pendant Travaux - Dossier N°{folderNumber}",
      "attachementTitle": "Liste des pièces jointes",
      "submit": "Enregistrer",
      "submitForValidation": "Enregistrer pour validation",
      "cancel": "Retour",
      "processing": "Traitement en cours...",
      "resultComment": "Commentaire"
  }
}
</i18n>

<template>
  <b-row :class="{noActive : isProcessing }" class="vpt">
    <div :class="{ 'no-data-message': isProcessing }" id="processing-message" class="message">
      <div class="content">
        <h4 class="align-center">
          <slot name="Loading">{{ this.$i18n.t('processing') }}</slot>
        </h4>
      </div>
    </div>
    <b-col :class="{ 'no-data': isProcessing }">
      <InfoBar :title="this.$i18n.t('title')" />

      <b-form class="mg-t-15" id="vpt" name="dynamic-validation" @submit.prevent="">
        <filesDropzone name="filesDropzone" />
        <CommonFields :title="this.$i18n.t('titleForm', { folderNumber: property.folderNumber})" />

        <div class="panel panel-info mg-b-15">
          <div class="panel-heading">{{ $t('Conclusion') }}</div>
          <div class="panel-body mt-2">
            <b-container fluid>
              <b-row>
                  <b-col sm="2">
                    <label for="textarea-small">{{$t('resultComment')}}</label>
                  </b-col>
                  <b-col sm="10">
                        <textarea
                          name="resultComment"
                          size="sm"
                          class="form-control"
                          v-model="getForm.resultComment"
                          rows="20"
                          cols="20"
                          max-rows="255"
                          :maxlength="$MAX_2000"
                          style="min-height:200px"
                        />
                  </b-col>
                  <b-col sm="12" class="text-right"><span>{{charactersRemaining}}/{{$MAX_2000}}</span></b-col>
               </b-row>
            </b-container>
            <b-form-checkbox
              plain
              id="result"
              name="result"
              v-model="getForm.result"
              class="form-group row"
            >Résultat conforme</b-form-checkbox>
          </div>
        </div>
        <b-row>
          <b-col cols="12" class="submit-form">
            <router-link
              class="btn btn-gray mg-r-10"
              :to="{ name: 'property_detail', params: { propertyId: property.id } }"
            >{{ $t('cancel') }}</router-link>

            <b-button type="submit" class="btn btn-cta s-btn" v-on:click="handleSubmitVpt('save')">
              <b-spinner v-if="isProcessing" />
              {{ $t('submit') }}
            </b-button>

            <b-button
              :disabled="dateOfVisitValidation"
              type="submit"
              class="btn btn-cta ml-3 disp-msg"
              v-on:click="handleSubmitVpt('saveForValidation')"
            >
              <b-spinner v-if="isProcessing" />
              {{ $t('submitForValidation') }}
            </b-button>
            <span v-if="dateOfVisitValidation" class="ndisp red">Date de visite non saisie</span>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish"></ajax-intercept>
  </b-row>
</template>

<script>
import CommonFields from '../fields/Common.vue';
import { TYPE_VPT } from '../../constants/params';
import InfoBar from '../properties/InfoBar';
import Dropzone from '../Dropzone';
import { mapGetters, mapState, mapActions } from 'vuex';
import ajaxIntercept from 'vue-ajax-intercept';

export default {
  name: 'VPT',
  components: {
    CommonFields,
    filesDropzone: Dropzone,
    InfoBar,
    ajaxIntercept,
  },
  data: () => ({
    isProcessing: false,
    submitType: 'save',
    ajaxInterceptorCounter: 0,
  }),
  created() {
    this.initVptForm();
    this.setTypeForm();
    this.initNotif();
  },
  computed: {
    ...mapGetters(['getForm']),
    ...mapState({ property: state => state.refProperties.property, vptForm: state => state.vpt.vptForm }),
    dateOfVisitValidation() {
      if (this.vptForm.dateOfVisit === undefined || this.vptForm.dateOfVisit === null) {
        return true;
      }
      return false;
    },
    charactersRemaining: function () {
      if(   this.getForm.resultComment )
       {
         return this.getForm.resultComment.length;
       }
       return 0;
      },
  },
  methods: {
    ...mapActions(['initNotif', 'initVptForm']),
    setTypeForm() {
      this.$store.commit('setTypeForm', TYPE_VPT);
    },
    handleSubmitVpt(submitType) {
      if (submitType === 'saveForValidation') {
        if (!confirm('Vous ne pourrez plus modifier le formulaire après cette action !')) {
          return;
        }
        this.getForm.forceStatusWaitingForValidation = true;
      }else{
        this.getForm.forceStatusWaitingForValidation = false;
      }

      this.isProcessing = true;
      this.setFilesInForm();
      this.$store.dispatch('handleSubmitVpt');
    },
    setFilesInForm() {
      var dropzoneComponent = this.$children.find(x => x.$attrs.name === 'filesDropzone');
      this.$store.dispatch('setFilesInForm', { component: dropzoneComponent, form: this.vptForm });
    },
    ajaxStart() {
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish() {
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
  },
};
</script>
